module.exports = require("lodash/maxBy");